module.exports = __webpack_public_path__ + "static/media/018.c608b54b.jpg";